import {
  Component,
  OnInit,
  ViewChild,
  ChangeDetectionStrategy
} from "@angular/core";
import {
  MdbTableDirective,
  MDBModalService,
  MDBModalRef
} from "ng-uikit-pro-standard";
import { AuthService } from "src/app/core";
import { ConfirmRedeemComponent } from "src/app/shared/components/popups/confirm-redeem/confirm-redeem.component";
import { ProductType } from "src/app/core/product/enums";
import { AppService } from "src/app/core/app/app.service";
import { Order } from "src/app/core/order/order.model";
import { Observable } from "rxjs";

@Component({
  selector: "ll-orders-table",
  templateUrl: "./orders-table.component.html",

  styleUrls: ["./orders-table.component.scss"]
})
export class OrdersTableComponent implements OnInit {
  modalRef: MDBModalRef;
  @ViewChild(MdbTableDirective, { static: true }) mdbTable: MdbTableDirective;
  public pageEnd: number;
  public itemsPerPage: number;
  public pageBegin: number;

  constructor(
    public app: AppService,
    public auth: AuthService,
    private modalService: MDBModalService
  ) {
    this.pageBegin = 0;
    this.pageEnd = this.itemsPerPageOptions[0];
    this.itemsPerPage = this.itemsPerPageOptions[0];
  }

  public get orders$(): Observable<Order[]> {
    return this.app.state.orders$;
  }

  public get itemsPerPageOptions(): number[] {
    return this.app.state.itemsPerPage;
  }
  public get currentSearchText(): string {
    return this.app.state.orderFilterSearchText;
  }

  ngOnInit() {
    this.pageEnd = 10;
    this.itemsPerPage = 10;
    this.pageBegin = 0;
  }

  getType(i: number): string {
    return ProductType[i];
  }

  filter(orders: Order[]): Order[] {
    return orders.filter(order => {
      let searchFlag: boolean =
        this.currentSearchText == null ||
        this.currentSearchText == "" ||
        order.user.email.includes(this.currentSearchText) ||
        order.user.name.includes(this.currentSearchText);
      return searchFlag;
    });
  }
  show(i: number) {
    return i >= this.pageBegin && i < this.pageEnd;
  }

  public get totalOrders(): number {
    return this.app.state.orderTableTotalOrders;
  }

  onNextPagePressed() {
    if (this.pageEnd >= this.totalOrders) return;
    this.pageBegin += this.itemsPerPage;
    this.pageEnd += this.itemsPerPage;
    if (this.pageEnd > this.totalOrders) this.pageEnd = this.totalOrders;
  }

  onPreviousPagePressed() {
    if (this.pageBegin <= 0) return;
    this.pageBegin -= this.itemsPerPage;
    this.pageEnd = this.pageBegin + this.itemsPerPage;
    if (this.pageBegin < 0) this.pageBegin = 0;
  }

  onItemsPerPageSelected(item: number) {
    this.itemsPerPage = item;
    this.pageBegin = 0;
    this.pageEnd = item;
  }

  redeem(order: Order) {
    this.modalRef = this.modalService.show(ConfirmRedeemComponent, {
      ignoreBackdropClick: true,
      class: "modal-dialog-centered",
      containerClass: "center",
      animated: true,
      data: {
        description:
          order.summary.redeemedAt == null
            ? "Are you sure you want to redeem this order?"
            : "Are you sure you want to un-redeem this order?"
      }
    });
    this.modalRef.content.action.subscribe((result: boolean) => {
      if (result) {
        order.summary.redeemedAt == null
          ? this.app.redeem(order)
          : this.app.unredeem(order);
      }
    });
  }

  mailTo(email: string) {
    return "mailto:" + email;
  }

  get isAdmin() {
    return this.app.state.isAdmin;
  }

  mask(email: string) {
    if (!email.includes("@")) return email;
    let x = email.split("@");
    return x[0] + "@" + "*".repeat(x[1].length - 1);
  }
}
